
export default {
  inserted: (el, bindings, vnode) ->
    # default append to <body>
    container = if bindings.arg then document.getElementById(bindings.arg) else document.body
    if container
      if bindings.modifiers.prepend and container.firstChild then container.insertBefore(el, container.firstChild) else container.appendChild(el)
      # bottom of target
    else
      console.warn 'v-' + name + ' target element id "' + bindings.arg + '" not found.'
    return
  unbind: (el) ->
    if el.parentNode
      el.parentNode.removeChild el
    return
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/directives/transferDom.vue